import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import Header from "../app/(general-header)/header/page";

const root = createRoot(document.getElementById("botb-header") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <Header />
    </StoreProvider>
  </React.StrictMode>
);
